import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import captchaEnviroments from './captchaEnviroments';
import React from 'react';

export const RecaptchaProvider:React.FC<{ children:React.ReactElement }> = ({ children }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={captchaEnviroments.SITE_KEY}
      container={{ // optional to render inside custom element
        element: 'reCaptcha',
        parameters: {
          badge: 'bottomright' // optional, default undefined
        }
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};
